import { DateRangeCalendar, Popover } from '@medly-components/core';
import styled from 'styled-components';

export const FlatDateRangePickerWrapper = styled(Popover)`
    display: inline-block;
    position: relative;

    ${DateRangeCalendar.Style} {
        top: 0;
    }
`;

export const FlatDateRangePickerButton = styled.button`
    display: flex;
    align-items: center;
    gap: 1.2rem;
    cursor: pointer;
    user-select: none;
    padding: 0.4rem 0.8rem;
    outline: none;
    border: none;
    background-color: transparent;
`;
